import React, { Component } from "react";
import Ionicon from "react-ionicons";

export default class ProfileVideo extends Component {
  render() {
    const { handleProfileVideoOpen } = this.props;

    return (
      <div className="row">
        <div className="col-xs-8 col-md-9">
          <p className="p-tag">
            <b>Watch</b> a short video explaining our <b>new website design</b>
          </p>
        </div>
        <div className="col-xs-4 col-md-3">
          <button
            className="btn-share"
            type="button"
            onClick={() => handleProfileVideoOpen()}
          >
            <span className="share-label">WATCH</span>
            <span className="share-icon">
              <Ionicon icon="ion-play" />
            </span>
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/ProfileVideo.js